module.exports = __webpack_public_path__ + "img/sDolphDive_193x205.991d9d3d.png";